<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<h1 class="title"><span class="bold">KOREAN WAR</span></h1>
<h1 class="titlea"><span class="bold">CHINESE INVASION</span></h1>
<p class="sub-title"><span class="bold">PEOPLE’S LIBERATION ARMY CROSSES THE YALU OCTOBER 1950—MARCH 1951</span></p>
<p class="author"><span class="bold">GERRY VAN TONDER</span></p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?35f27e90